import { cn } from "@/utils/cn";
import { IonButton } from "@ionic/react";

interface FilledButtonProps {
  text?: string;
  type?: "button" | "submit" | "reset";
  children?: React.ReactNode;
  size?: "small" | "default" | "large";
  color?: string;
  expand?: "block" | "full";
  className?: string;
  disabled?: boolean;
  shape?: "round";
  onClick?: () => void;
  style?: React.CSSProperties;
}

export default function FilledButton({
  text,
  type = "button",
  children,
  size = "small",
  color = "light",
  expand = "block",
  disabled = false,
  shape = "round",
  className,
  onClick,
  style,
}: FilledButtonProps) {
  return (
    <IonButton
      className={cn("no-capitalize flex-1 rounded-4xl border normal-case", className)}
      size={size}
      fill="solid"
      color={color}
      shape={shape}
      expand={expand}
      onClick={onClick}
      disabled={disabled}
      type={type}
      style={{ textTransform: "none", fontWeight: "600", ...style }}
    >
      {text || children}
    </IonButton>
  );
}
